import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

export default function CookieBanner({ onOpenDatenschutz }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if consent has already been given or declined
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Show the banner after a small delay for a smoother feel
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 50, opacity: 0, scale: 0.95 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 50, opacity: 0, scale: 0.95 }}
          transition={{ type: "spring", stiffness: 300, damping: 28 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-8 md:max-w-md z-40 bg-pearl/90 backdrop-blur-md border border-line/60 rounded-xl p-6 shadow-2xl text-charcoal"
          data-testid="cookie-banner"
        >
          <div className="flex gap-4 items-start">
            <div className="p-2 bg-sand rounded-lg border border-line/30 text-stone shrink-0">
              <Cookie className="h-5 w-5" />
            </div>
            <div className="space-y-4">
              <div>
                <h4 className="font-serif-display font-medium text-lg leading-none mb-2 text-charcoal">
                  Cookie-Hinweis
                </h4>
                <p className="text-xs text-stone/85 leading-relaxed font-light">
                  Diese Website verwendet Cookies, um eine einwandfreie Nutzung zu garantieren. Durch Klicken auf „Akzeptieren“ stimmen Sie der Verwendung zu. Weitere Informationen finden Sie in unserer{" "}
                  <button
                    onClick={onOpenDatenschutz}
                    className="underline text-charcoal font-normal hover:text-stone transition-colors cursor-pointer inline focus:outline-none"
                    data-testid="cookie-banner-privacy-link"
                  >
                    Datenschutzerklärung
                  </button>
                  .
                </p>
              </div>

              <div className="flex justify-end gap-3 pt-2">
                <button
                  onClick={handleDecline}
                  className="px-4 py-2 border border-line hover:border-charcoal hover:bg-sand rounded-full text-[10px] tracking-[0.15em] uppercase text-stone hover:text-charcoal transition-all cursor-pointer focus:outline-none active:scale-[0.98]"
                  data-testid="cookie-banner-decline"
                >
                  Ablehnen
                </button>
                <button
                  onClick={handleAccept}
                  className="px-5 py-2 bg-charcoal hover:bg-stone text-pearl rounded-full text-[10px] tracking-[0.15em] uppercase transition-all shadow-md shadow-charcoal/10 cursor-pointer focus:outline-none active:scale-[0.98]"
                  data-testid="cookie-banner-accept"
                >
                  Akzeptieren
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
